import gql from 'graphql-tag';

const MUTATION_DELETE_SEMINAR_SIGNUP = gql`
	mutation DeleteSeminarSignup($id: String!) {
		deleteSeminarSignup(id: $id)
	}
`;

export default MUTATION_DELETE_SEMINAR_SIGNUP;